export function logEvent(event) {
    window.ReactNativeWebView.postMessage(event);
}
